module.exports = __webpack_public_path__ + "static/media/undefined.ff72071a.webp";